var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({ fontSize: _vm.lablefont == '边框' ? '0' : '' })},_vm._l((_vm.footList),function(item2,index2){return _c('span',{key:index2},[(item2.label == '边框')?_c('span',{style:({
        border: '1px solid #636363',
        padding: '2px 0',
      })},[_c('footNote',{attrs:{"footList":item2.content,"changefontSize":_vm.changefontSize,"lablefont":"边框"}})],1):_vm._e(),_vm._v(" "),(item2.label == 'text')?_c('span',{style:({
        fontSize: 16 * (1 + _vm.changefontSize / 100) + 'px',
      }),domProps:{"innerHTML":_vm._s(_vm.brightenKeyword(item2.content, _vm.keyword))}}):_vm._e(),_vm._v(" "),(item2.label == '图')?_c('img',{style:({
        margin: '0 auto',
        width: item2.widthsel,
        height: item2.hightsel,
      }),attrs:{"src":_vm.baseImgPath + _vm.bookName + '/' + item2.content,"alt":""}}):_vm._e(),_vm._v(" "),(item2.label == '字图')?_c('img',{style:({
        height: item2.size
          ? parseInt(16 * (1 + _vm.changefontSize / 100)) +
            parseInt(item2.size) +
            'px'
          : 16 * (1 + _vm.changefontSize / 100) + 'px',
        width: 'auto',
      }),attrs:{"src":_vm.baseImgPath + _vm.bookName + '/' + item2.content,"alt":""}}):_vm._e(),_vm._v(" "),(item2.label == '脚注小字')?_c('span',{style:({
        fontSize: 12 * (1 + _vm.changefontSize / 100) + 'px',
      }),domProps:{"innerHTML":_vm._s(_vm.brightenKeyword(item2.content, _vm.keyword))}}):_vm._e(),_vm._v(" "),(item2.label == '脚注段落')?_c('span',[_c('br'),_c('br')]):_vm._e(),_vm._v(" "),(item2.label == 'xiaoji')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.brightenKeyword(item2.content, _vm.keyword))}}):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7f159ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/footNote.vue
// module id = null
// module chunks = 